import * as t from 'io-ts';
export const ModelPartitionKey = t.type({
    partitionKey: t.string,
});
export function fromAttributes(tenant, productId) {
    return `${tenant}#${productId}`;
}
